import { systemConnectionTestAsync, testSystemConnection } from '@Actions';
import { FLAGS } from '@Types/flags';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useFeatureFlagConfiguration from './useFeatureFlagConfigurations';
import useSensorTroubleshoot from './useSensorTroubleshoot';

type SystemConnectionTestReturn = {
	isTestButtonDisabled: boolean;
	triggerSystemConnection: () => void;
};

export const useSystemConnectionTest = (
	isLoading: boolean,
	credentials: Record<string, string>,
): SystemConnectionTestReturn => {
	const dispatch = useDispatch();

	const isNewSensorTestEnabled = useIsFeatureEnabled(
		FLAGS.NEW_SENSOR_SYSTEM_TESTS,
	);

	const { asyncTestsTimeoutMs } = useFeatureFlagConfiguration();

	const areCredentialsPopulated = (
		credentials: Record<string, string>,
	): boolean => {
		for (const credentialsKey in credentials) {
			if (!credentials[credentialsKey]) {
				return false;
			}
		}
		return true;
	};

	const isTestButtonDisabled = useMemo(() => {
		return isLoading || !areCredentialsPopulated(credentials);
	}, [isLoading, credentials]);

	const triggerSystemConnection = (): void => {
		console.debug({ isNewSensorTestEnabled });
		if (isNewSensorTestEnabled) {
			const request = {
				credentials,
				timeoutSec: asyncTestsTimeoutMs / 1000,
			};
			dispatch(systemConnectionTestAsync(request));
		} else {
			dispatch(testSystemConnection({ credentials })); // ? legacy
		}
	};

	return {
		isTestButtonDisabled,
		triggerSystemConnection,
	};
};

export default useSensorTroubleshoot;
